export const menuItems = [
    { id: 1, label: 'Select Pages', key: 'selectpages' },
    { id: 2, label: 'Finalize', key: 'finalize' },
    { id: 3, label: 'Review', key: 'review' },
];
